import { render, staticRenderFns } from "./manage-facture.html?vue&type=template&id=07bbe8a5&scoped=true&external"
import script from "./manage-facture.js?vue&type=script&lang=js&external"
export * from "./manage-facture.js?vue&type=script&lang=js&external"
import style0 from "./manage-facture.scss?vue&type=style&index=0&id=07bbe8a5&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bbe8a5",
  null
  
)

export default component.exports